"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isFoquzAvailable = exports.isFoquzUiTestEnv = exports.isFoquzUnavailableHost = exports.FOQUZ_AVAILABILITY_POLL_MAX_ATTEMPTS = exports.FOQUZ_AVAILABILITY_POLL_MS = exports.FOQUZ_UNAVAILABLE_HOSTS = exports.FOQUZ_UI_TEST_ENV_COOKIE = void 0;
exports.FOQUZ_UI_TEST_ENV_COOKIE = 'is_ui_test_env';
exports.FOQUZ_UNAVAILABLE_HOSTS = ['rb.m2', 'm2.region.vtb.ru'];
exports.FOQUZ_AVAILABILITY_POLL_MS = 500;
exports.FOQUZ_AVAILABILITY_POLL_MAX_ATTEMPTS = 10;
function isFoquzUnavailableHost(hostname) {
    const normalized = hostname.split(',')[0].split(':')[0].trim().toLowerCase();
    return exports.FOQUZ_UNAVAILABLE_HOSTS.some((host) => normalized === host || normalized.endsWith(`.${host}`));
}
exports.isFoquzUnavailableHost = isFoquzUnavailableHost;
function isFoquzUiTestEnv() {
    if (typeof document === 'undefined')
        return false;
    return document.cookie.split(';').some((part) => part.trim() === `${exports.FOQUZ_UI_TEST_ENV_COOKIE}=true`);
}
exports.isFoquzUiTestEnv = isFoquzUiTestEnv;
function isFoquzAvailable(hostname) {
    if (typeof window === 'undefined')
        return false;
    const host = hostname !== null && hostname !== void 0 ? hostname : window.location.hostname;
    if (isFoquzUnavailableHost(host))
        return false;
    if (isFoquzUiTestEnv())
        return false;
    const widget = window.FQZWidget;
    return typeof (widget === null || widget === void 0 ? void 0 : widget.triggerEvent) === 'function';
}
exports.isFoquzAvailable = isFoquzAvailable;
//# sourceMappingURL=availability.js.map